import { useState } from "react";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

/** Fichas de trabajo: la familia marca el estado y escribe sus observaciones. */
export const WorksheetList = ({ sheets, onSave, testid = "worksheets" }) => (
  <ul className="mt-5 space-y-4" data-testid={`${testid}-list`}>
    {sheets.length === 0 && (
      <li className="text-lg text-ink-700">Todavía no hay fichas de trabajo asignadas.</li>
    )}
    {sheets.map((w) => <WorksheetItem key={w.id} sheet={w} onSave={onSave} />)}
  </ul>
);

const WorksheetItem = ({ sheet, onSave }) => {
  const [notes, setNotes] = useState(sheet.notes || "");
  const done = sheet.status === "completada";
  return (
    <li className="rounded-xl border border-border p-4" data-testid={`worksheet-${sheet.id}`}>
      <p className="text-lg font-medium">{sheet.title}</p>
      <p className="text-base text-ink-700">Fecha de entrega: {sheet.due_date}</p>
      <p className="mt-2">
        <span data-testid={`worksheet-status-${sheet.id}`}
          className={`inline-block rounded-full px-3 py-1 text-sm font-semibold ${
            done ? "bg-logo-light text-logo-text" : "bg-amber-100 text-amber-900"}`}>
          {done ? "COMPLETADA" : "NO COMPLETADA"}
        </span>
      </p>
      <Button data-testid={`worksheet-toggle-${sheet.id}`} variant="outline" className="mt-3 h-12 text-base"
        onClick={() => onSave(sheet.id, { status: done ? "no_completada" : "completada" })}>
        {done ? "Marcar como no completada" : "Marcar como completada"}
      </Button>
      <div className="mt-4">
        <p className="text-base font-medium">Observaciones</p>
        <Textarea data-testid={`worksheet-notes-${sheet.id}`} rows={3} className="mt-2 text-base"
          placeholder="Indique cómo ha ido la actividad, dificultades o cualquier comentario."
          value={notes} onChange={(e) => setNotes(e.target.value)} />
        <Button data-testid={`worksheet-notes-save-${sheet.id}`} variant="outline"
          className="mt-2 h-12 text-base" onClick={() => onSave(sheet.id, { notes })}>
          Guardar observaciones
        </Button>
      </div>
    </li>
  );
};
